import { render, staticRenderFns } from "./TrainingSection.vue?vue&type=template&id=163efc51&scoped=true"
import script from "./TrainingSection.vue?vue&type=script&lang=js"
export * from "./TrainingSection.vue?vue&type=script&lang=js"
import style0 from "./TrainingSection.vue?vue&type=style&index=0&id=163efc51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163efc51",
  null
  
)

export default component.exports